// extracted by mini-css-extract-plugin
export default {"icon":"TooltipIcon_icon__-+IHA"};